import React, { useEffect, useState, useRef } from "react";
import { Card, CardBody, CardHeader } from "./../../components/card/card.jsx";
import { asset, customer } from "../../api/index.js";
import { toast } from "react-toastify";
import { useAuth } from "../../contexts/AuthContext.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useNavigate, useRoutes } from "react-router-dom";
import ConfirmationDlg from "../../components/ConfirmationDlg/index.jsx";
import { Loader } from "../../utils/helper";
import DataTable from "react-data-table-component";
import ImageViewer from "../../components/ImageViewer";

function CustomerList() {
  const [datas, setDatas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [query, setQuery] = useState({ page: 1,take:10,totalData:1 });
  const { config } = useAuth();
  const { machineTypes } = useDashboardContext();
  const [deleteRow, setDeleteRow] = useState(null);
  const [changeStatus, setChangeStatus] = useState(null);
  const navigate = useNavigate();

  async function getData() {
    try {
      setLoading(true);
      const queryParam = {
        ...query,
      };
      const res = await customer.list(queryParam);
      if (res.ok) {
        const body = await res.json();
        let data = body.data;
        if (data.results) {
          setDatas(data.results);
        }
        if (data.totalData) {
          setQuery((prev) => ({
            ...prev,
            totalData:data.totalData
          }))
        }
      }
      setLoading(false);
    } catch (e) {
      setLoading(false);
      toast.error(e.message);
      console.error(e);
    }
  }

  function changeOperation(value) {
    openChangeStatus(value);
  }

  function generateLocationWording() {
    let result = [];
    if (config && config?.location_wording) {
      const words = config?.location_wording.split(",");
      words.forEach((ln, index) => {
        result.push(ln);
      });
    }

    return result;
  }

  function showConfirmationDlg(row) {
    setDeleteRow(row);
  }

  function hideConfirmationDialog() {
    setDeleteRow(null);
  }

  function openChangeStatus(value) {
    setChangeStatus(value);
  }

  function hideChangeStatus() {
    setChangeStatus(null);
  }

  function countOnlineOffline(machine) {
    let online = 0;
    let offline = 0;
    machine.machine_elements.forEach((cm) => {
      if (
        cm.deployments[0]?.sensor?.sensor_uptime[0]?.on_off_status === "true"
      ) {
        online++;
      } else {
        offline++;
      }
    });
    return { online, offline };
  }

  async function deleteData() {
    try {
      const response = await customer.delete(deleteRow.id);
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("This customer has been deleted");

          setDeleteRow(null);
          await getData()
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
      console.error(e);
    }
  }

  const columns = [
    {
      name: "Customer Name",
      selector: (row) => row.customer_name,
      minWidth: "150px",
    },
    {
      name: "Customer Type",
      selector: (row) => row.type?.name,
      
    },
    {
      name: "Website",
      selector: (row) => row.website,
    },
    {
      name: "Contact Name",
      selector: (row) => row.contact_name,
    },
    {
      name: "Action",
      cell: (row) => (
        <div className="d-flex">
          <button
            className="btn btn-sm btn-outline-theme me-2"
            onClick={() => {
              navigate(`/customer/edit/${row.id}`);
            }}
          >
            View
          </button>

          <button
            className="btn btn-sm btn-outline-danger ml-2"
            onClick={() => {
              showConfirmationDlg(row);
            }}
          >
            Delete
          </button>

        </div>
      ),
    },
  ];

  const handleChangeLocationFilter = (location_id) => {
    setQuery((prev) => ({
      ...prev,
      location_id: location_id ? location_id : "",
    }));
  };

  const handleChangeMachineType = (machine_type_id) => {
    setQuery((prev) => ({
      ...prev,
      machine_type_id: machine_type_id,
    }));
  };

  useEffect(() => {
    getData();
    // eslint-disable-next-line
  }, [query.page,query.take]);

  const onChangeStatus = (e) => {
    setChangeStatus((prev) => ({
      ...prev,
      machine_status: e.target.value,
    }));
  };

  const prosesChangeStatus = async () => {
    try {
      const response = await customer.updateStatus(
        changeStatus.id,
        changeStatus.machine_status
      );
      if (response.ok) {
        const body = await response.json();
        if (body.success) {
          toast.success("Machine Status has been changed");

          setChangeStatus(null);
        } else {
          toast.error(body.message);
        }
      }
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <div className="container">
      <div className="row justify-content-center">
        <div className="col-xl-12">
          <ul className="breadcrumb">
            <li className="breadcrumb-item">
              <a href="#/">VENDOR</a>
            </li>
            <li className="breadcrumb-item active">VENDOR LIST</li>
          </ul>

          <h1 className="page-header">Customer List</h1>

          <hr className="mb-4" />

          <div id="datatable" className="mb-5">
            <div className="row mb-2 justify-content-sm-end">
             
              <div className="col-sm-3 mb-2 mb-sm-0">
                <button
                  onClick={() => {
                    navigate("/customer/add");
                  }}
                  className="btn btn-outline-theme w-100"
                >
                  Add Customer <i className="bi bi-plus"></i>
                </button>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <Card>
                  <CardBody>
          
                      <DataTable
                        progressPending={loading}
                        pointerOnHover
                        onRowClicked={(row) => {
                          navigate(`/customer/edit/${row.id}`);
                        }}
                        highlightOnHover
                        theme="dark"
                        columns={columns}
                        data={datas}
                      pagination
                      paginationServer
                      onChangeRowsPerPage={(row)=>setQuery((prev)=>({...prev,page:1,take:row}))}
                      paginationTotalRows={query.totalData}
                      onChangePage={(page)=>setQuery((prev)=>({...prev,page:page}))}
                      />
                
                  </CardBody>
                </Card>
              </div>
            </div>
          </div>
        </div>
      </div>

      {deleteRow && (
        <ConfirmationDlg
          title={"Delete Customer"}
          open={!!deleteRow}
          onClose={hideConfirmationDialog}
          onSubmit={deleteData}
        >
          <p style={{ pb: 2 }}>
            Are you sure you want to delete this Customer{" "}
            <strong>{deleteRow.customer_name}</strong> ?
          </p>
        </ConfirmationDlg>
      )}
      {changeStatus && (
        <ConfirmationDlg
          title={"Change Machine Status"}
          open={!!changeStatus}
          onClose={hideChangeStatus}
          btnSubmitText={"Update"}
          btnCancelText={"Cancel"}
          onSubmit={prosesChangeStatus}
        >
          <p style={{ pb: 2 }}>
            Change Status of <strong>{changeStatus.machine_name}</strong> ?
          </p>
          <div className="form-group">
            <select
              className={"form-select "}
              value={changeStatus?.machine_status}
              onChange={onChangeStatus}
            >
              <option value="Operational">Operational</option>
              <option value="Maintenance">Maintenance</option>
              <option value="Repair">Repair</option>
              <option value="Archived">Archived</option>
            </select>
          </div>
        </ConfirmationDlg>
      )}
    </div>
  );
}

export default CustomerList;
